import { gql } from '@apollo/client'

export const REQUEST_APPOINTMENT = gql`
  mutation RequestAppointment(
    $locationId: ID!
    $patient: PatientInput!
    $partnerId: ID
    $providerId: ID
    $referrer: String!
    $locale: Locale
    $source: String
    $attributionData: AttributionDataInput
  ) {
    requestAppointment(
      locationId: $locationId
      patient: $patient
      partnerId: $partnerId
      providerId: $providerId
      referrer: $referrer
      locale: $locale
      source: $source
      attributionData: $attributionData
    ) {
      __typename
      ... on AppointmentRequest {
        id
        insertedAt
        isEmergency
        locale
      }
      ... on UserInputValidationFailed {
        message
        fieldErrors {
          field
          message
          errors {
            field
            message
          }
        }
      }
    }
  }
`
